import { faCircleCheck } from '@fortawesome/free-regular-svg-icons'
import { faDownload, faFileExport, faUpload, faXmark } from '@fortawesome/free-solid-svg-icons'
import { Dialog, DialogContent, DialogTitle, Icon, Button, Skeleton } from '@/presentation/components/atoms'
import { ORDER_STATUS } from '@/main/utils/constants'
import { useFilesDownload } from '@/presentation/pages/orders/listOrders/hooks/useFilesDownload'
import { useDialogs } from '@/main/hooks'
import { useOrderMutations } from '@/presentation/pages/orders/listOrders/hooks/useOrderMutations'

export const BrokerOptionsDialog = ({ order, isOpen, onClose }) => {
  const { getBrokerOrderLayout, isGettingBrokerOrderLayout, getBrokerOrderXlsx, isGettingBrokerOrderXlsx } =
    useFilesDownload({
      orderId: order.id,
      orderCode: order.code,
      identifier: 'optionDialog',
    })

  const { sendBrokerOrderSlip, sendBrokerOrderPaymentProof } = useOrderMutations({
    config: {
      sendBrokerOrderSlip: {
        onSuccess: () => setDialog({ dialog: 'brokerOrderOptions', props: { order: { ...order, orderStatus: 6 } } }),
      },
    },
  })

  const { setDialog } = useDialogs()
  const isLoading =
    isGettingBrokerOrderXlsx ||
    isGettingBrokerOrderLayout ||
    sendBrokerOrderSlip.isLoading ||
    sendBrokerOrderPaymentProof.isLoading

  const closeIfNotWaiting = isLoading ? null : onClose
  return (
    <Dialog open={isOpen} onClose={closeIfNotWaiting}>
      <DialogTitle>
        Ações sobre pedido
        <Icon icon={faXmark} onClick={closeIfNotWaiting} />
      </DialogTitle>
      <DialogContent
        sx={{
          display: 'flex',
          flexDirection: 'column',
          gap: '16px',
          marginTop: '32px',
          padding: isLoading ? '48px' : 0,
        }}
      >
        {isLoading ? (
          <>
            <Skeleton variant='rounded' height='48px' width='295px' />
            <Skeleton variant='rounded' height='48px' width='295px' />
            <Skeleton variant='rounded' height='48px' width='295px' />
            <Skeleton variant='rounded' height='48px' width='295px' />
          </>
        ) : (
          <>
            <Button variant='contained' onClick={() => getBrokerOrderXlsx()} startIcon={<Icon icon={faDownload} />}>
              Download de pedido
            </Button>
            <Button variant='outlined' onClick={() => getBrokerOrderLayout()} startIcon={<Icon icon={faFileExport} />}>
              Exportar arquivo de pedido
            </Button>
            <Button
              variant='outlined'
              startIcon={<Icon icon={faUpload} />}
              onClick={() =>
                setDialog({
                  dialog: 'attachBrokerOrderSlip',
                  props: {
                    order,
                    onConfirm: (data) => {
                      sendBrokerOrderSlip.mutate({ orderId: order.id, payload: data })
                    },
                  },
                })
              }
            >
              Anexar boleto gerado
            </Button>
            <Button
              disabled={order.orderStatus !== ORDER_STATUS.RUNNING}
              variant='outlined'
              startIcon={<Icon icon={faCircleCheck} />}
              onClick={() =>
                setDialog({
                  dialog: 'attachBrokerOrderPaymentProof',
                  props: {
                    order,
                    onConfirm: (data) => {
                      sendBrokerOrderPaymentProof.mutate({ orderId: order.id, payload: data })
                      setDialog({ dialog: null })
                    },
                  },
                })
              }
            >
              Confirmar pagamento
            </Button>
          </>
        )}
      </DialogContent>
    </Dialog>
  )
}
